import React, { useState, useEffect, useCallback, useMemo } from "react";
import _debounce from "lodash/debounce";
import { useSelector } from "react-redux";

import FilterByForDashboard from "../FilterByForDashboard";
import IndexIndecator from "../../IndexIndicator/IndexIndecator";
import QuantityIndecator from "./brandScorecardComponents/QuantityIndecator";
import GrowYourBrand from "./brandScorecardComponents/GrowYourBrand";
import IdentifyWhitespace from "./brandScorecardComponents/IdentifyWhitespace";
import StrengthenCompetitiveEdge from "./brandScorecardComponents/StrengthenCompetitiveEdge";
import RefineYourTarget from "./brandScorecardComponents/RefineYourTarget";
import { useGlobalContext } from "../../../context/GlobalContext";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Divider } from "primereact/divider";
import StrengthOpportunitiesCard from "./brandScorecardComponents/StrengthOpportunitiesCard";
import {
  getDayOfWeekAndWeekPartChartForCoaster,
  getHouseHoldChartData,
  getHouseHoldCoasterChartData,
  getProductAttributeChartData,
  getTimeOfDayChart,
  getTimeOfDayChartForCoaster,
  getUsePerDayAndWeekChartDataForCoaster,
  getUsePerDayChartData,
  getWeekPartChart,
} from "../../../services/dashboard/frequency";
import {
  getBrandPreferenceChartData,
  getOverAllSatisfactionChartData,
} from "../../../services/dashboard/experience";
import ChartSectionBlock from "./brandScorecardComponents/ChartSectionBlock";
import { Panel } from "primereact/panel";
import ChartComponent from "./brandScorecardComponents/ChartComponent";
import {
  APP_CONSTANT,
  INDEX_SCORE_INDICATOR,
  COMMON_PAGE_BOTTOM_TEXT,
  BASE_SIZE_MIN_VALUE,
  BASE_SIZE_MID_VALUE,
  SURVEY_BASE_SIZE_MIN_VALUE,
  SURVEY_BASE_SIZE_MID_VALUE,
  AVERAGE_WEEKLY_FREQUENCY_TEXT,
  getAppConstantCategoryValue,
} from "../../../utils/constants";
import {
  getNeedsChartData,
  getOccasionsChartData,
} from "../../../services/dashboard/needsAndOccasions";
import { toSentenceCase } from "../../../utils/constants";
import BrandsSkeleton from "../../Skeletons/BrandsSkeleton";
import { exportToExcel } from "./brandScorecardComponents/ExportToExcel";
import { validateCompareObjectValues } from "../../../utils/filterBy/filterBy";
import { exportToExcelV2 } from "./brandScorecardComponents/ExportToExcelV2";
import ChartSkeleton from "../../Skeletons/ChartSkeleton";

const BrandScorecard = (props) => {
  const {
    productType = "",
    brandsLoading,
    selectedFilters,
    setSelectedFilters,
    isFilterByApplied,
    setIsFilterByApplied,
    selectedFilterValues,
    setSelectedFilterValues,
  } = props;

  const {
    device,
    deviceCode,
    category,
    product_id,
    mappedCategory,
    project_id,
    showSidebar,
    isCustomRecruitCategory,
  } = useGlobalContext();
  const {
    brandsList,
    occasionsListData,
    hideFilter: isFilterHide,
  } = useSelector((state) => state.dashboard);
  const { filter_week, end_date } = useSelector((state) => state.dateRange);
  const { token, user } = useSelector((state) => state.auth);

  const [loading, setLoading] = useState(false);
  const [activeOption, setActiveOption] = useState("FILTERBY");
  // const [selectedFilters, setSelectedFilters] = useState({});
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [selectedGenders, setSelectedGenders] = useState([]);
  const [selectedOccasions, setSelectedOccasions] = useState([]);
  const [selectedHouseHoldAge, setSelectedHouseHoldAge] = useState([]);
  const [selectedHouseHoldIncome, setSelectedHouseHoldIncome] = useState([]);
  const [selectedHouseHoldSize, setSelectedHouseHoldSize] = useState([]);
  const [selectedHouseHoldChildren, setSelectedHouseHoldChildren] = useState(
    [],
  );
  const [selectedHouseHoldRaceEthnicity, setSelectedHouseHoldRaceEthnicity] =
    useState([]);
  const [selectedForms, setSelectedForms] = useState([]);
  const [selectedDayPart, setSelectedDayPart] = useState([]);
  const [selectedWeekPart, setSelectedWeekPart] = useState([]);
  const [selectedTimeOfDay, setSelectedTimeOfDay] = useState([]);
  const [filterByApply, setFilterByApply] = useState(false);
  const [brandsApply, setBrandsApply] = useState(false);
  const [activeTag, setActiveTag] = useState("GM");
  const [filterBrandValue, setFilterBrandValue] = useState("");
  const [brandsListData, setBrandsListData] = useState(brandsList);
  const [selectedBrandsData, setSelectedBrandsData] = useState([]);
  const [usePerWeekGraphData, setUsePerWeekGraphData] = useState("");
  const [satifactionChartData, setSatifactionChartData] = useState("");
  const [brandPreferenceChartData, setBrandPreferenceChartData] = useState("");
  const [showBrandNameValidation, setShowBrandNameValidation] = useState(true);

  const handleTagClick = (tag) => {
    setActiveTag(tag);
  };
  // const [isFilterHide, setIsFilterHide] = useState(false);
  const [brandHeader, setBrandHeader] = useState("Brand name");
  const [brandHeaderEditValue, setBrandHeaderEditValue] = useState("");
  const [isEditMode, setIsEditMode] = useState(false);
  const [strengthAndOpportunitiesData, setStrengthAndOpportunitiesData] =
    useState({
      strengths: [],
      opportunities: [],
    });
  const [excelExportData, setExcelExportData] = useState({
    timeOfDayData: [],
    weekpartData: [],
    needsData: [],
    occasionsData: [],
  });
  const [strAndOpprLoading, setStrAndOpprLoading] = useState(false);

  const memoizedTooltipFrequency = useMemo(() => {
    return <div>Average count of uses per week per product</div>;
  }, []);
  const memoizedTooltipSatisfaction = useMemo(() => {
    return (
      <div>
        Thinking about the[product] that you used at [time], how satisfied are
        you with this product for this occasion? (Select One) <br />
        <br />
        +5 Very satisfied <br />
        +4 Somewhat satisfied <br />
        +3 Neutral <br />
        +2 Somewhat unsatisfied <br />
        +1 Very unsatisfied
      </div>
    );
  }, []);
  const memoizedTooltipBrandPrf = useMemo(() => {
    return (
      <div>
        If you had NOT been able to choose this brand for this particular
        occasion, how would you feel? If you had NOT been able to choose this
        brand for this particular occasion, how would you feel? <br />
        <br />
        (+3) Disappointed – this is not my preferred brand for this occasion{" "}
        <br />
        (+2) Neutral – another brand would probably be just as good <br />
        (+1) Okay – this brand is especially good for this occasion
        <br />
      </div>
    );
  }, []);

  useEffect(() => {
    if (productType !== "" && parseInt(deviceCode) !== 1) {
      if (occasionsListData?.question_id !== "") {
        fetchChartsDataForSensor();
      }
    }
  }, [
    productType,
    props?.apply,
    filterByApply,
    occasionsListData?.question_id,
    brandsApply,
    filter_week,
  ]);

  useEffect(() => {
    if (parseInt(deviceCode) === 1 && !brandsLoading) {
      fetchChartsDataForCoaster();
      if (props?.compareBy?.key_2?.value !== "") {
        fetchStrengthAndOpportunitiesCoaster();
      } else {
        setStrengthAndOpportunitiesData({
          strengths: [],
          opportunities: [],
        });
      }
    }
  }, [
    productType,
    props?.apply,
    filterByApply,
    brandsApply,
    filter_week,
    brandsLoading,
  ]);

  useEffect(() => {
    if (
      selectedBrandsData.length > 1 &&
      brandHeader.toLowerCase() === "brand name"
    ) {
      setShowBrandNameValidation(true);
    } else {
      setShowBrandNameValidation(false);
    }
  }, [selectedBrandsData, brandHeader]);

  const getSelectedCategoriesString = () => {
    const categories = [];

    if (selectedHouseHoldAge.length > 0) {
      categories.push("age");
    }
    if (selectedHouseHoldIncome.length > 0) {
      categories.push("income");
    }
    if (selectedHouseHoldSize.length > 0) {
      categories.push("size");
    }
    if (selectedHouseHoldChildren.length > 0) {
      categories.push("children");
    }
    if (selectedHouseHoldRaceEthnicity.length > 0) {
      categories.push("raceEthnicity");
    }

    return categories.join("|");
  };

  const requestBodyForSensor = {
    compare_with: "brand",
    occasion_question_id: occasionsListData?.question_id,
    // compare_by: {
    //   key_1: {
    //     name: APP_CONSTANT.CATEGORY_LABEL,
    //     value: APP_CONSTANT.CATEGORY_VALUE,
    //   },
    //   key_2: {
    //     name:
    //       brandHeader.toLowerCase() !== "brand name"
    //         ? brandHeader
    //         : selectedBrandsData?.length < 2
    //           ? `${selectedBrandsData[0]}`
    //           : `Column 2`,
    //     value: selectedBrandsData.join("|"),
    //   },
    // },
    compare_by: {
      key_1: {
        name: getAppConstantCategoryValue(isCustomRecruitCategory),
        value: getAppConstantCategoryValue(isCustomRecruitCategory),
      },
      key_2: {
        name: props?.compareBy?.key_2?.name,
        value: props?.compareBy?.key_2?.value,
      },
    },
    filter_occasion: selectedOccasions.join("|"),
    filter_household: isFilterByApplied
      ? selectedFilterValues?.houseHold
        ? Object.values(selectedFilterValues?.houseHold)
            .flat()
            .map((item) => item.uniques.trim())
            .filter((value) => value !== "All") // Remove "All" if present
            .join("|")
        : ""
      : "",
    filter_household_type: getSelectedCategoriesString(),
    filter_consumer_segment: "",
    filter_brand: "",
    filter_form: selectedForms.join("|"),
    project_id: parseInt(project_id),
    section_type:
      props?.chooseComparison && validateCompareObjectValues(props?.compareBy)
        ? "compare"
        : "filter",
    mapped_category: mappedCategory,
    filter_week: filter_week,
  };

  const requestBodyForCoaster = {
    compare_with: "brand",
    // compare_by: {
    //   key_1: {
    //     name: APP_CONSTANT.CATEGORY_LABEL,
    //     value: APP_CONSTANT.CATEGORY_VALUE,
    //   },
    //   key_2: {
    //     name:
    //       brandHeader.toLowerCase() !== "brand name"
    //         ? brandHeader
    //         : selectedBrandsData?.length < 2
    //           ? `${selectedBrandsData[0]}`
    //           : `Column 2`,
    //     value: selectedBrandsData.join("|"),
    //   },
    // },
    compare_by: {
      key_1: {
        name: getAppConstantCategoryValue(isCustomRecruitCategory),
        value: getAppConstantCategoryValue(isCustomRecruitCategory),
      },
      key_2: {
        name: props?.compareBy?.key_2?.name,
        value: props?.compareBy?.key_2?.value,
      },
    },
    chart_type: "",
    filter_occasion: selectedOccasions.join("|"),
    filter_household: isFilterByApplied
      ? selectedFilterValues?.houseHold
        ? Object.values(selectedFilterValues?.houseHold)
            .flat()
            .map((item) => item.uniques.trim())
            .filter((value) => value !== "All") // Remove "All" if present
            .join("|")
        : ""
      : "",
    filter_household_type: getSelectedCategoriesString(),
    filter_consumer_segment: "",
    filter_product_category: parseInt(product_id),
    filter_product_type: productType,
    filter_brand: "",
    filter_form: selectedForms.join("|"),
    filter_day_part: selectedDayPart.join("|"),
    filter_week_part: selectedWeekPart.join("|"),
    graph_type: "no_of_use",
    how_long_use_per: "",
    project_id: parseInt(project_id),
    cat_id: parseInt(product_id),
    cat_name: category,
    section_type:
      props?.chooseComparison && validateCompareObjectValues(props?.compareBy)
        ? "compare"
        : "filter",
    how_often_use_per: "",
    mapped_category: mappedCategory,
    filter_week: filter_week,
  };

  const fetchChartsDataForSensor = () => {
    setLoading(true);
    fetchFrequencyChart();
    fetchSatisfactionChart();
    fetchBrandPreferenceChart();
    if (props?.compareBy?.key_2?.value !== "") {
      fetchStrengthAndOpportunities();
    } else {
      setStrengthAndOpportunitiesData({
        strengths: [],
        opportunities: [],
      });
    }
  };

  const fetchChartsDataForCoaster = () => {
    setLoading(true);
    fetchCoasterFrequencyChart();
  };

  const fetchFrequencyChart = () => {
    getUsePerDayChartData(
      {
        ...requestBodyForSensor,
        filter_product_category: parseInt(product_id),
        chart_type: "how_often",
        how_often_use_per: "week",
        occasion_question_id: occasionsListData?.question_id,
        filter_product_type: productType,
        filter_day_part: selectedDayPart.join("|"),
        filter_week_part: selectedWeekPart.join("|"),
        graph_type: "total_average",
      },
      token,
    )
      .then((usePerWeekResponse) => {
        setUsePerWeekGraphData(usePerWeekResponse.data.graphs);
      })
      .catch((error) => {
        console.error("Error fetching chart data:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const processExportData = (exportType) => {
    if (exportType === "frequency") {
      const dataItems = usePerWeekGraphData?.datasets || [];
      if (dataItems?.length > 1) {
        const dataSetVal = dataItems[1]; // column2 data array
        const dataSetCategoryVal = dataItems[0]; // column1 data array
        let getIndexValue = dataSetVal?.index?.length
          ? dataSetVal?.index[1]
          : (dataSetVal.data[1] / dataSetCategoryVal.data[0]) * 100;
        getIndexValue = isNaN(getIndexValue) ? 0 : getIndexValue;
        const item = {
          labelOne: "",
          labelTwo: AVERAGE_WEEKLY_FREQUENCY_TEXT,
          value: parseInt(getIndexValue),
          isShowAsteriskSign: false,
          category_avg: dataSetCategoryVal.data[0],
          brandVal: dataSetVal.data[1],
          categoryBaseSize: dataSetCategoryVal?.participant[0] || 0,
          brandBaseSize: dataSetVal?.participant[1] || 0,
          individualBrandBaseSizeVal: 0,
        };

        return [item];
      } else {
        return [];
      }
    }

    let expExportData = [];

    if (exportType === "expExport") {
      const dataItems = satifactionChartData?.datasets || [];
      if (dataItems?.length > 1) {
        const dataSetVal = dataItems[1]; // column2 data array
        const dataSetCategoryVal = dataItems[0]; // column1 data array
        let getIndexValue =
          (dataSetVal.data[1] / dataSetCategoryVal.data[0]) * 100;
        getIndexValue = isNaN(getIndexValue) ? 0 : getIndexValue;
        const item = {
          labelOne: "",
          labelTwo: "Product Satisfaction - Mean Score (5 point scale)",
          value: parseInt(getIndexValue),
          isShowAsteriskSign: false,
          category_avg: dataSetCategoryVal.data[0],
          brandVal: dataSetVal.data[1],
          categoryBaseSize: dataSetCategoryVal?.total_response || 0,
          brandBaseSize: dataSetVal?.total_response || 0,
          individualBrandBaseSizeVal: dataSetVal?.participant?.length
            ? dataSetVal?.participant[1]
            : 0,
        };

        expExportData.push(item);
      }

      const brandDataItems = brandPreferenceChartData?.datasets || [];
      if (brandDataItems?.length > 1) {
        const dataSetVal = brandDataItems[1]; // column2 data array
        const dataSetCategoryVal = brandDataItems[0]; // column1 data array
        let getIndexValue =
          (dataSetVal.data[1] / dataSetCategoryVal.data[0]) * 100;
        getIndexValue = isNaN(getIndexValue) ? 0 : getIndexValue;
        const item = {
          labelOne: "",
          labelTwo:
            "Brand Preference - % Disappointed if could not choose brand",
          value: parseInt(getIndexValue),
          isShowAsteriskSign: false,
          category_avg: dataSetCategoryVal.data[0],
          brandVal: dataSetVal.data[1],
          categoryBaseSize: dataSetCategoryVal?.total_response || 0,
          brandBaseSize: dataSetVal?.total_response || 0,
          individualBrandBaseSizeVal: dataSetVal?.participant?.length
            ? dataSetVal?.participant[1]
            : 0,
        };

        expExportData.push(item);
      }
    }

    return expExportData;
  };

  const fetchStrengthAndOpportunities = async () => {
    setStrengthAndOpportunitiesData({
      strengths: [],
      opportunities: [],
    });
    setStrAndOpprLoading(true);
    try {
      const reqPayload = {
        ...requestBodyForSensor,
        filter_product_category: parseInt(product_id),
        chart_type: "how_often",
        how_often_use_per: "",
        occasion_question_id: occasionsListData?.question_id,
        filter_product_type: productType,
        filter_day_part: selectedDayPart.join("|"),
        filter_week_part: selectedWeekPart.join("|"),
        sub_graph_type: "percentage_of_total",
      };

      Promise.allSettled([
        getWeekPartChart(
          {
            ...reqPayload,
            graph_type: "weekly_average",
          },
          token,
        ),
        getTimeOfDayChart(
          {
            ...reqPayload,
            graph_type: "day_average",
          },
          token,
        ),
        // getHouseHoldChartData(
        //   {
        //     ...reqPayload,
        //     graph_type: "total_average",
        //     how_often_use_per: "week",
        //   },
        //   token,
        // ),
        // getProductAttributeChartData(
        //   {
        //     ...reqPayload,
        //     graph_type: "total_average",
        //     how_often_use_per: "week",
        //   },
        //   token,
        // ),
        getOccasionsChartData(
          {
            ...requestBodyForSensor,
            product_id: parseInt(product_id),
            product_type: "product",
            filter_gender: "",
            question_id: occasionsListData?.question_id,
          },
          token,
        ),
        getNeedsChartData(
          {
            ...requestBodyForSensor,
            product_id: parseInt(product_id),
            product_type: "product",
          },
          token,
        ),
      ])
        .then(
          ([
            weekPartResponse,
            timeOfDayResponse,
            // householdDataResponse,
            // productAttDataResponse,
            occasionsResponse,
            needsResponse,
          ]) => {
            setStrengthAndOpportunitiesData({
              strengths: [],
              opportunities: [],
            });
            const weekpartData =
              weekPartResponse.status === "fulfilled"
                ? processResponseForStrnthNdOpprtnty(
                    weekPartResponse?.value?.data?.graphs?.datasets,
                    "percentage",
                    "weekpart",
                  )
                : { strengths: [], opportunities: [], exportData: [] };
            const timeOfDayData =
              timeOfDayResponse.status === "fulfilled"
                ? processResponseForStrnthNdOpprtntyTwo(
                    timeOfDayResponse?.value?.data?.graphs,
                    "percentage", //check data below 5
                    "timeofday",
                  )
                : { strengths: [], opportunities: [], exportData: [] };
            // const householdData =
            //   householdDataResponse.status === "fulfilled"
            //     ? processResponseForStrnthNdOpprtnty(
            //         householdDataResponse?.value?.data?.graphs?.datasets,
            //         "base-size", //check participant below 50
            //         "household",
            //       )
            //     : { strengths: [], opportunities: [] };
            // const productAttData =
            //   productAttDataResponse.status === "fulfilled"
            //     ? processResponseForStrnthNdOpprtnty(
            //         productAttDataResponse?.value?.data?.graphs?.datasets,
            //         "base-size",
            //         "productAtt",
            //       )
            //     : { strengths: [], opportunities: [] };
            const occasionsData =
              occasionsResponse.status === "fulfilled"
                ? processResponseForStrnthNdOpprtntyTwo(
                    occasionsResponse?.value?.data.graphs,
                    "percentage",
                    "occasion",
                  )
                : { strengths: [], opportunities: [], exportData: [] };
            const needsData =
              needsResponse.status === "fulfilled"
                ? processResponseForStrnthNdOpprtntyTwo(
                    needsResponse?.value?.data.graphs,
                    "percentage",
                    "need",
                  )
                : { strengths: [], opportunities: [], exportData: [] };

            setStrengthAndOpportunitiesData((prevProp) => ({
              strengths: [
                ...prevProp.strengths,
                ...timeOfDayData.strengths,
                ...weekpartData.strengths,
                // ...householdData.strengths,
                // ...productAttData.strengths,
                ...occasionsData.strengths,
                ...needsData.strengths,
              ],
              opportunities: [
                ...prevProp.opportunities,
                ...timeOfDayData.opportunities,
                ...weekpartData.opportunities,
                // ...householdData.opportunities,
                // ...productAttData.opportunities,
                ...occasionsData.opportunities,
                ...needsData.opportunities,
              ],
            }));

            setExcelExportData({
              timeOfDayData: timeOfDayData.exportData,
              weekpartData: weekpartData.exportData,
              occasionsData: occasionsData.exportData,
              needsData: needsData.exportData,
            });
          },
        )
        .catch((error) => {
          console.error("Error fetching chart data:", error);
        })
        .finally(() => {
          setStrAndOpprLoading(false);
        });
    } catch (error) {
      console.error("Error fetching chart data:", error);
    }
  };

  const fetchStrengthAndOpportunitiesCoaster = async () => {
    setStrengthAndOpportunitiesData({
      strengths: [],
      opportunities: [],
    });
    setStrAndOpprLoading(true);
    try {
      Promise.allSettled([
        getTimeOfDayChartForCoaster(
          {
            ...requestBodyForCoaster,
            how_often_use_per: "",
            sub_graph_type: "percentage_of_total",
          },
          token,
        ),
        getDayOfWeekAndWeekPartChartForCoaster(
          {
            ...requestBodyForCoaster,
            day_type: "week",
            how_often_use_per: "",
            sub_graph_type: "percentage_of_total",
            chart_type: "how_often",
          },
          token,
        ),
        // getHouseHoldCoasterChartData(
        //   {
        //     ...requestBodyForCoaster,
        //     day_type: "week",
        //     how_often_use_per: "",
        //   },
        //   token,
        // ),
      ])
        .then(
          ([timeOfDayResponse, weekPartResponse, householdDataResponse]) => {
            setStrengthAndOpportunitiesData({
              strengths: [],
              opportunities: [],
            });
            const weekpartData =
              weekPartResponse.status === "fulfilled"
                ? processResponseForStrnthNdOpprtnty(
                    weekPartResponse?.value?.data?.graphs?.datasets,
                    "percentage",
                    "weekpart",
                  )
                : { strengths: [], opportunities: [], exportData: [] };
            const timeOfDayData =
              timeOfDayResponse.status === "fulfilled"
                ? processResponseForStrnthNdOpprtntyTwo(
                    timeOfDayResponse?.value?.data?.graphs,
                    "percentage",
                    "timeofday",
                  )
                : { strengths: [], opportunities: [], exportData: [] };
            // const householdData =
            //   householdDataResponse.status === "fulfilled"
            //     ? processResponseForStrnthNdOpprtnty(
            //         householdDataResponse?.value?.data?.graphs?.datasets,
            //         "base-size",
            //         "household",
            //       )
            //     : { strengths: [], opportunities: [] };

            setStrengthAndOpportunitiesData((prevProp) => ({
              strengths: [
                ...prevProp.strengths,
                ...timeOfDayData.strengths,
                ...weekpartData.strengths,
                // ...householdData.strengths,
              ],
              opportunities: [
                ...prevProp.opportunities,
                ...timeOfDayData.opportunities,
                ...weekpartData.opportunities,
                // ...householdData.opportunities,
              ],
            }));

            setExcelExportData({
              timeOfDayData: timeOfDayData.exportData,
              weekpartData: weekpartData.exportData,
            });
          },
        )
        .catch((error) => {
          console.error("Error fetching chart data:sdfdsfsdfsdfsdfsd", error);
        })
        .finally(() => {
          setStrAndOpprLoading(false);
        });
    } catch (error) {
      console.error("Error fetching chart data:", error);
    }
  };

  const fetchCoasterFrequencyChart = () => {
    getUsePerDayAndWeekChartDataForCoaster(
      { ...requestBodyForCoaster, day_type: "week" },
      token,
    )
      .then((usePerWeekResponse) => {
        setUsePerWeekGraphData(usePerWeekResponse.data.graphs);
      })
      .catch((error) => {
        console.error("Error fetching chart data:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const fetchSatisfactionChart = () => {
    getOverAllSatisfactionChartData(
      {
        ...requestBodyForSensor,
        box_type: "Mean",
        product_type: productType,
        product_id: parseInt(product_id),
      },
      token,
    )
      .then((satisfactionResponse) => {
        setSatifactionChartData(satisfactionResponse.data.graphs);
      })
      .catch((error) => {
        console.error("Error fetching chart data:", error);
      })
      .finally(() => {
        // setLoading(false);
      });
  };

  const fetchBrandPreferenceChart = () => {
    getBrandPreferenceChartData(
      {
        ...requestBodyForSensor,
        box_type: "Single",
        product_type: productType,
        product_id: parseInt(product_id),
      },
      token,
    )
      .then((brandprefResponse) => {
        setBrandPreferenceChartData(brandprefResponse.data.graphs);
      })
      .catch((error) => {
        console.error("Error fetching chart data:", error);
      })
      .finally(() => {
        // setLoading(false);
      });
  };

  useEffect(() => {
    if (props?.selectedComparitionBy === "brand") {
      setSelectedBrands([]);
    }
    if (props?.selectedComparitionBy === "form") {
      setSelectedForms([]);
    }
    if (props?.selectedComparitionBy === "household") {
      setSelectedFilters({});
    }
  }, [props?.selectedComparitionBy]);

  useEffect(() => {
    setSelectedDayPart([]);
    setSelectedWeekPart([]);
    setSelectedBrands([]);
    setSelectedOccasions([]);
    // setSelectedFilters({});
    setSelectedForms([]);
    setSelectedBrandsData([]);
    setUsePerWeekGraphData("");
    setSatifactionChartData("");
    setBrandPreferenceChartData("");
  }, [parseInt(product_id)]);

  useEffect(() => {
    setBrandsListData(brandsList);
    setSelectedBrandsData([]);
  }, [brandsList]);

  const handleReset = () => {
    setSelectedDayPart([]);
    setSelectedWeekPart([]);
    setSelectedBrands([]);
    setSelectedOccasions([]);
    setSelectedFilters({});
    setSelectedForms([]);
    setFilterByApply(!filterByApply);
    setIsFilterByApplied(false);
    setSelectedFilterValues({});
  };

  const handleDebounceFn = (inputValue) => {
    if (inputValue !== "") {
      const filteredBrandsList = brandsList.filter((item) =>
        item.toLowerCase().includes(inputValue.toLowerCase()),
      );
      setBrandsListData(filteredBrandsList);
    } else {
      setBrandsListData(brandsList);
    }
  };

  const debounceFn = useCallback(_debounce(handleDebounceFn, 500), [
    brandsList,
  ]);

  // process response of stacked bar type chart data
  const processResponseForStrnthNdOpprtnty = (
    datasets,
    asteriskType,
    dataType,
  ) => {
    let strengths = [];
    let opportunities = [];
    let exportData = [];
    if (datasets && datasets?.length > 0 && datasets[0].data.length > 1) {
      for (let i = 0; i < datasets.length; i++) {
        if (datasets[i].label !== "") {
          if (
            asteriskType === "percentage" &&
            datasets[i]?.data[1] < 5 &&
            datasets[i]?.data[0] < 5
          ) {
            continue;
          }
          let getIndexValue = (datasets[i].data[1] / datasets[i].data[0]) * 100;
          getIndexValue = isNaN(getIndexValue) ? 0 : getIndexValue;

          let showAsteriskSign = false;
          let includeVal = true;
          let dataTypeVal = "";

          if (dataType === "timeofday") {
            dataTypeVal = "Time of day:";
          }
          if (dataType === "weekpart") {
            dataTypeVal = `${datasets[i]?.label.split(" ")[0] || "Week Part"}:`;
          }
          if (dataType === "household" || dataType === "productAtt") {
            dataTypeVal = `${datasets[i]?.segment_label}:` || "";
          }
          if (asteriskType === "percentage" && datasets[i].data[1] < 5) {
            showAsteriskSign = true;
          }
          if (asteriskType === "base-size" && datasets[i].participant[1] < 50) {
            showAsteriskSign = true;
            if (datasets[i].participant[1] === 0) {
              includeVal = false;
            }
          }

          const item = {
            labelOne: `${dataTypeVal}`,
            labelTwo: `${datasets[i].label}`,
            value: parseInt(getIndexValue),
            isShowAsteriskSign: showAsteriskSign,
            category_avg: datasets[i].data[0],
            brandVal: datasets[i].data[1],
            categoryBaseSize:
              dataType === "weekpart"
                ? datasets[0]?.total_participant[0] || 0
                : datasets[0]?.participant[0] + datasets[1]?.participant[0] ||
                  0,
            brandBaseSize:
              dataType === "weekpart"
                ? datasets[0]?.total_participant[1] || 0
                : datasets[0]?.total_participant[1] +
                    datasets[1]?.participant[1] || 0,
            individualBrandBaseSizeVal: datasets[i]?.participant?.length
              ? datasets[i]?.participant[1]
              : 0,
          };

          if (includeVal) {
            if (
              datasets[i].data[0] > 0 &&
              getIndexValue > INDEX_SCORE_INDICATOR.GREEN_TEXT_VALUE
            ) {
              strengths.push(item);
              exportData.push(item);
            }

            if (
              datasets[i].data[0] > 0 &&
              getIndexValue < INDEX_SCORE_INDICATOR.RED_TEXT_VALUE
            ) {
              opportunities.push(item);
              exportData.push(item);
            }

            if (
              datasets[i].data[0] > 0 &&
              getIndexValue >= INDEX_SCORE_INDICATOR.GREY_TEXT_MIN_VALUE &&
              getIndexValue <= INDEX_SCORE_INDICATOR.GREY_TEXT_MAX_VALUE
            ) {
              exportData.push(item);
            }
          }
        }
      }
      return {
        strengths,
        opportunities,
        exportData,
      };
    } else {
      return {
        strengths,
        opportunities,
        exportData,
      };
    }
  };
  // process occassion and needs response
  const processResponseForStrnthNdOpprtntyTwo = (
    dataItems,
    asteriskType,
    dataType,
  ) => {
    let strengths = [];
    let opportunities = [];
    let exportData = [];
    if (dataItems && dataItems?.datasets && dataItems?.datasets?.length > 1) {
      const dataSetVal = dataItems?.datasets[1]; // column2 data array
      const dataSetCategoryVal = dataItems?.datasets[0]; // column1 data array
      const itemLabels = dataItems?.labels;
      for (let i = 0; i < itemLabels.length; i++) {
        if (itemLabels[i] !== "") {
          if (
            asteriskType === "percentage" &&
            dataSetVal?.data[i] < 5 &&
            dataSetCategoryVal?.data[i] < 5
          ) {
            continue;
          }
          let getIndexValue =
            (dataSetVal.data[i] / dataSetCategoryVal.data[i]) * 100;
          getIndexValue = isNaN(getIndexValue) ? 0 : getIndexValue;
          let showAsteriskSign = false;

          let dataTypeVal = "";
          if (dataType === "timeofday") {
            dataTypeVal = "Time of day";
          }
          if (dataType === "occasion") {
            dataTypeVal = "Occasion";
          }
          if (dataType === "need") {
            dataTypeVal = "Need";
          }

          if (asteriskType === "percentage" && dataSetVal.data[i] < 5) {
            showAsteriskSign = true;
          }
          const item = {
            labelOne: `${dataTypeVal}:`,
            labelTwo: `${itemLabels[i]}`,
            value: parseInt(getIndexValue),
            isShowAsteriskSign: showAsteriskSign,
            category_avg: dataSetCategoryVal.data[i],
            brandVal: dataSetVal.data[i],
            categoryBaseSize: dataSetCategoryVal?.total_response || 0,
            brandBaseSize: dataSetVal?.total_response || 0,
            individualBrandBaseSizeVal: dataSetVal?.participant?.length
              ? dataSetVal?.participant[i]
              : 0,
          };

          if (
            dataSetCategoryVal.data[i] > 0 &&
            getIndexValue > INDEX_SCORE_INDICATOR.GREEN_TEXT_VALUE
          ) {
            strengths.push(item);
            exportData.push(item);
          }

          if (
            dataSetCategoryVal.data[i] > 0 &&
            getIndexValue < INDEX_SCORE_INDICATOR.RED_TEXT_VALUE
          ) {
            opportunities.push(item);
            exportData.push(item);
          }

          if (
            dataSetCategoryVal.data[i] > 0 &&
            getIndexValue >= INDEX_SCORE_INDICATOR.GREY_TEXT_MIN_VALUE &&
            getIndexValue <= INDEX_SCORE_INDICATOR.GREY_TEXT_MAX_VALUE
          ) {
            exportData.push(item);
          }
        }
      }
      return {
        strengths,
        opportunities,
        exportData,
      };
    } else {
      return {
        strengths,
        opportunities,
        exportData,
      };
    }
  };

  const handleFilterApply = () => {
    setSelectedFilterValues((prevProp) => {
      return {
        ...prevProp,
        houseHold: selectedFilters,
      };
    });
  };

  return (
    <div className="row pb-4">
      <FilterByForDashboard
        loading={loading}
        setLoading={setLoading}
        device={device}
        deviceCode={deviceCode}
        category={category}
        product_id={product_id}
        productType={productType}
        activeOption={activeOption}
        setActiveOption={setActiveOption}
        selectedForms={selectedForms}
        setSelectedForms={setSelectedForms}
        selectedBrands={selectedBrands}
        setSelectedBrands={setSelectedBrands}
        selectedGenders={selectedGenders}
        setSelectedGenders={setSelectedGenders}
        selectedOccasions={selectedOccasions}
        setSelectedOccasions={setSelectedOccasions}
        selectedHouseHoldAge={selectedHouseHoldAge}
        setSelectedHouseHoldAge={setSelectedHouseHoldAge}
        selectedHouseHoldIncome={selectedHouseHoldIncome}
        setSelectedHouseHoldIncome={setSelectedHouseHoldIncome}
        selectedHouseHoldSize={selectedHouseHoldSize}
        setSelectedHouseHoldSize={setSelectedHouseHoldSize}
        selectedHouseHoldChildren={selectedHouseHoldChildren}
        setSelectedHouseHoldChildren={setSelectedHouseHoldChildren}
        selectedHouseHoldRaceEthnicity={selectedHouseHoldRaceEthnicity}
        setSelectedHouseHoldRaceEthnicity={setSelectedHouseHoldRaceEthnicity}
        selectedDayPart={selectedDayPart}
        setSelectedDayPart={setSelectedDayPart}
        selectedWeekPart={selectedWeekPart}
        setSelectedWeekPart={setSelectedWeekPart}
        selectedTimeOfDay={selectedTimeOfDay}
        setSelectedTimeOfDay={setSelectedTimeOfDay}
        apply={filterByApply}
        setApply={(filterByflagValue) => {
          setFilterByApply(filterByflagValue);
          setIsFilterByApplied(true);
          handleFilterApply();
        }}
        isCompareByClicked={props?.isCompareByClicked}
        setIsCompareByClicked={props?.setIsCompareByClicked}
        setSelectedFilters={setSelectedFilters}
        selectedFilters={selectedFilters}
        handleReset={handleReset}
        // setIsFilterHide={(toggle) => setIsFilterHide(toggle)}
        selectedComparitionBy={props?.selectedComparitionBy}
        mappedCategory={mappedCategory}
        isShowBrands={false}
      />
      <div
        className={isFilterHide ? `col-12` : `col-9`}
        style={{ padding: "0px 3%" }}
      >
        {/* <IndexIndecator />
        <QuantityIndecator
          activeTag={activeTag}
          setActiveTag={setActiveTag}
          handleTagClick={handleTagClick}
        />
        <GrowYourBrand />
        <IdentifyWhitespace />
        <StrengthenCompetitiveEdge />
        <RefineYourTarget /> */}
        {/* <div className="my-4 text-start">
          <h6 className="fw-semibold text-start text_dark">Select a Brand</h6>
          <p
            className="mb-0 text-start fw-bold fs-12 pb-3"
            style={{ color: "#9E9E9E" }}
          >
            To group brands, select multiple brands below. Click on the blue
            pencil and type in a name for the custom group. Click "Apply" to
            populate scorecard
          </p>
          {brandsLoading ? (
            <div className="row">
              <div className="col-6">
                <BrandsSkeleton />
              </div>
            </div>
          ) : (
            <div className="row">
              <div className="col-6">
                {!isEditMode ? (
                  <div className="d-flex align-items-center">
                    <div
                      className="column-heading"
                      style={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        // minWidth: "165px",
                        // maxWidth: "165px"
                      }}
                    >
                      {brandHeader}
                    </div>
                    <span
                      className="pi pi-pencil pencil-icon ms-2"
                      onClick={() => {
                        setIsEditMode(!isEditMode);
                      }}
                    ></span>
                  </div>
                ) : (
                  <div className="d-flex align-items-center">
                    <InputText
                      value={isEditMode ? brandHeaderEditValue : brandHeader} // Ensure value is empty initially
                      onChange={(e) => setBrandHeaderEditValue(e.target.value)}
                      className="mb-1 column-input"
                      placeholder={`Enter Brand`}
                    />
                    <div className="filter-input-buttons d-flex align-items-center">
                      <Button
                        className="filter-input-button1 me-1"
                        onClick={() => {
                          setBrandHeader(
                            brandHeaderEditValue
                              ? brandHeaderEditValue
                              : "Brand name",
                          );
                          setIsEditMode(false);
                        }}
                      >
                        <span className="pi pi-check"></span>
                      </Button>
                      <Button
                        className="filter-input-button2"
                        aria-label="Cancel"
                        onClick={() => {
                          setBrandHeaderEditValue("");
                          setBrandHeader("Brand name");
                          setIsEditMode(false);
                        }}
                      >
                        <span className="pi pi-times"></span>
                      </Button>
                    </div>
                  </div>
                )}
                {brandsList.length ? (
                  <>
                    <div className="search-filter d-flex align-items-center mt-2">
                      <span className="search-icon pi pi-search text-secondary pe-2"></span>
                      <InputText
                        name={`search_key`}
                        value={filterBrandValue}
                        onChange={(e) => {
                          setFilterBrandValue(e.target.value);
                          debounceFn(e.target.value);
                        }}
                        className="mb-1 search-input column-input"
                        placeholder={`Search brands`} // Placeholder for each search
                        // style={{
                        //   backgroundColor: "#f5f5f5"
                        // }}
                      />
                    </div>

                    <div className="brand-list scroll-panel-custom panel-height">
                      {brandsListData.map((brand, index) => (
                        <div
                          key={index}
                          className="d-flex align-items-center pt-2 pb-2"
                        >
                          <Checkbox
                            inputId={`${index}`}
                            checked={selectedBrandsData.includes(brand)}
                            onChange={() => {
                              if (selectedBrandsData.includes(brand)) {
                                const filterSelectedBrands =
                                  selectedBrandsData.filter(
                                    (selectedBrand) =>
                                      selectedBrand.toLowerCase() !==
                                      brand.toLowerCase(),
                                  );
                                setSelectedBrandsData(filterSelectedBrands);
                              } else {
                                setSelectedBrandsData((prev) => [
                                  brand,
                                  ...prev,
                                ]);
                              }
                            }}
                          />
                          <label
                            htmlFor={`${index}`}
                            className="ms-2"
                            style={{
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                            title={brand}
                          >
                            {toSentenceCase(brand)}
                          </label>
                        </div>
                      ))}
                    </div>

                    <div className="d-flex align-items-center gap-2 managed-row mt-4">
                      <Button
                        label="Reset"
                        className="p-button-text me-2 resetButton br-c fw-600"
                        style={{ width: "100px", color: "gray" }}
                        disabled={selectedBrandsData.length === 0}
                        onClick={() => {
                          setBrandsApply(!brandsApply);
                          setSelectedBrandsData([]);
                        }}
                      ></Button>
                      <Button
                        label="Apply"
                        className="p-button-text me-2 active-button br-c fw-600"
                        style={{ width: "100px" }}
                        disabled={
                          selectedBrandsData.length === 0 ||
                          loading ||
                          showBrandNameValidation
                        }
                        onClick={() => setBrandsApply(!brandsApply)}
                      ></Button>

                      {showBrandNameValidation ? (
                        <div
                          className="brand-name-validation ms-3 py-1 px-2"
                          style={{
                            backgroundColor: "#dc3545",
                            color: "#fff",
                            borderRadius: "4px",
                            fontWeight: "600",
                          }}
                        >
                          <span className="pi pi-exclamation-triangle"></span>{" "}
                          Please name your columns to populate charts
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </>
                ) : (
                  ""
                )}
              </div>
            </div>
          )}
        </div>

        <Divider align="center" /> */}

        <Panel className="mt-2 text-start">
          <h4 className="fw-semibold text-start py-3 text_dark">
            Brand Performance
            {/* <span className="text-lowercase">{props?.compareBy?.key_2?.name ? `: ${props?.compareBy?.key_2?.name}` : ""}</span> */}
          </h4>
          {!loading && !brandsLoading ? (
            <div className="row charts-section">
              {!usePerWeekGraphData ? (
                ""
              ) : (
                <div
                  className={`mb-3 frequency-chart col-12 ${!satifactionChartData && !brandPreferenceChartData ? "col-md-12" : !satifactionChartData || !brandPreferenceChartData ? "col-md-6" : "col-md-4"}`}
                >
                  <div className="chart-block p-3">
                    <ChartSectionBlock
                      chartData={usePerWeekGraphData}
                      chartTypeText={AVERAGE_WEEKLY_FREQUENCY_TEXT}
                      chartSubText={"Average count of product uses per week"}
                      isFilterHide={isFilterHide}
                      showSidebar={showSidebar}
                      tooltipSubtext={memoizedTooltipFrequency}
                      loading={loading || brandsLoading}
                    />
                  </div>
                </div>
              )}
              {deviceCode !== 1 ? (
                <>
                  {!satifactionChartData ? (
                    ""
                  ) : (
                    <div
                      className={`mb-3 satisfaction-chart col-12 ${!usePerWeekGraphData && !brandPreferenceChartData ? "col-md-12" : !usePerWeekGraphData || !brandPreferenceChartData ? "col-md-6" : "col-md-4"}`}
                    >
                      <div className="chart-block p-3">
                        <ChartSectionBlock
                          chartData={satifactionChartData}
                          chartTypeText={"Product Satisfaction"}
                          chartSubText={"Mean Score - 5 point scale"}
                          isFilterHide={isFilterHide}
                          showSidebar={showSidebar}
                          tooltipSubtext={memoizedTooltipSatisfaction}
                          loading={loading || brandsLoading}
                        />
                      </div>
                    </div>
                  )}
                  {!brandPreferenceChartData ? (
                    ""
                  ) : (
                    <div
                      className={`col-12 mb-3 brand-preference-chart ${!satifactionChartData && !usePerWeekGraphData ? "col-md-12" : !satifactionChartData || !usePerWeekGraphData ? "col-md-6" : "col-md-4"}`}
                    >
                      <div className="chart-block p-3">
                        <ChartSectionBlock
                          chartData={brandPreferenceChartData}
                          chartTypeText={"Brand Preference"}
                          chartSubText={
                            "% survey responses disappointed if brand wasn't available"
                          }
                          isFilterHide={isFilterHide}
                          showSidebar={showSidebar}
                          tooltipSubtext={memoizedTooltipBrandPrf}
                          loading={loading || brandsLoading}
                        />
                      </div>
                    </div>
                  )}
                </>
              ) : (
                ""
              )}
            </div>
          ) : (
            <ChartSkeleton />
          )}
        </Panel>

        <Divider align="center" />
        {props?.compareBy?.key_2?.value !== "" ? (
          <>
            <div className="strength-opportunity-wrapper my-4">
              <h4 className="fw-semibold text-start text_dark">Gap Analysis</h4>
              <p
                className="mb-0 text-start fw-bold fs-12 pb-3"
                style={{ color: "#9E9E9E", fontSize: "15px" }}
              >
                XMOT<sup>&reg;</sup> Occasions & Needs Indexed to Category
                Benchmark - (n=survey responses)
              </p>
              <div className="row">
                <div className="col-12 col-md-6 strength-block">
                  <StrengthOpportunitiesCard
                    headerText={"Strengths"}
                    calculationValue={"Index > 120"}
                    itemsData={strengthAndOpportunitiesData.strengths}
                    loading={loading || brandsLoading || strAndOpprLoading}
                  />
                </div>
                <div className="col-12 col-md-6 opportunity-block">
                  <StrengthOpportunitiesCard
                    headerText={"Opportunities"}
                    calculationValue={"Index < 80"}
                    itemsData={strengthAndOpportunitiesData.opportunities}
                    loading={loading || brandsLoading || strAndOpprLoading}
                  />
                </div>
              </div>
            </div>
            <Divider align="center" />
          </>
        ) : (
          ""
        )}
        {props?.compareBy?.key_2?.value !== "" && !strAndOpprLoading ? (
          <>
            <div className="d-flex justify-content-between align-items-start">
              <div className="mt-3 d-flex justify-content-start">
                {/* <p
                  style={{
                    color: "#9e9e9e",
                    fontSize: "12px",
                    fontWeight: "bold",
                  }}
                >{`Exclude Variable < 5%`}</p> */}
                <div
                  className="text-light-gray text-start"
                  style={{
                    fontSize: "12px",
                    fontWeight: "bold",
                  }}
                >
                  {/* {COMMON_PAGE_BOTTOM_TEXT} */}
                  <div>{`*Low sample (n<${BASE_SIZE_MIN_VALUE} products)`}</div>
                  <div>{`^Directional Use Only (n=${BASE_SIZE_MID_VALUE} products)`}</div>
                  <div>{`*Low sample (n<${SURVEY_BASE_SIZE_MIN_VALUE} survey responses)`}</div>
                  <div>{`^Directional Use Only (n=${SURVEY_BASE_SIZE_MID_VALUE} survey responses)`}</div>
                </div>
              </div>
              <div className="mt-3 d-flex justify-content-end">
                <Button
                  label="Export Data"
                  className="p-button-text fs-12 p-1 me-2 active-button br-c fw-600"
                  onClick={() =>
                    exportToExcelV2(
                      [
                        {
                          strengths: strengthAndOpportunitiesData.strengths,
                          opportunities:
                            strengthAndOpportunitiesData.opportunities,
                        },
                      ],
                      "gap_analysis.xlsx",
                      props?.compareBy?.key_2?.name,
                      excelExportData,
                      filter_week,
                      end_date,
                      processExportData("frequency"),
                      processExportData("expExport"),
                      isCustomRecruitCategory,
                    )
                  }
                ></Button>
              </div>
            </div>
          </>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default BrandScorecard;
